import { Tooltip } from '@mui/material'
import {
    Modal,
    ModalBody,
    ModalContent,
    useDisclosure,
} from '@nextui-org/react'
import cn from 'classnames'
import React, { useState } from 'react'
import LazyLoad from 'react-lazy-load'

import AssetPreviewDisplay from '../assetpreviewdisplay/AssetPreviewDisplay'
import BackedInfo from '../backedinfo/BackedInfo'
import { MarketCard } from '../card/MarketCard'
import Link2 from '../common/util/input/Link2'
import { MintInfo } from '../mintinfo/MintInfo'
import RankInfo from '../rankinfo/RankInfo'
import { useSharedState } from '../waxplorer/Waxplorer'
import { AssetDetailsPopupContent } from './AssetDetailsPopupContent'
import { AuctionTimeleft } from './AuctionTimeleft'
import { CollectionAssetName } from './CollectionAssetName'
import { MarketAssetPreviewInfo } from './MarketAssetPreviewInfo'
import MoreOptions from './MoreOptions'
import { useTheme } from 'next-themes'
import { AuctionButtons } from '../marketbuttons/AuctionButtons'
import { useToast } from '../ui/use-toast'
import { showErrorToast, showSuccessToast } from '../../utils/toasts'
import { ModalActions } from './ModalActions'

// @ts-ignore
const AuctionAssetPreview = ({
    auction,
    onAdd,
    page,
    showOwner,
    searchOwner,
    clickAsset,
    index,
    assetType,
    previewDuration = 2,
}) => {
    const [state, dispatch] = useSharedState()
    const { theme } = useTheme()
    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null
    const [currentAsset, setCurrentAsset] = useState(0)
    const [newOwner, setNewOwner] = useState(null)
    const [showMenu, setShowMenu] = useState(false)
    const [error, setError] = useState(null)
    const [canceled, setCanceled] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [transferred, setTransferred] = useState(false)
    const [bidPlaced, setBidPlaced] = useState(false)
    const [ended, setEnded] = useState(false)
    const [action, setAction] = useState(null)

    const { assets, auctionId, market } = auction

    const asset = assets[currentAsset]

    let {
        assetId,
        collection,
        name,
        mint,
        rank,
        rarityScore,
        backedTokens,
        claimer,
        template,
    } = asset

    const handleCallBack = (info, action) => {
        if (info) {
            if (info['success']) {
                if (action === 'bid') {
                    setBidPlaced(true)
                    const bids = auction['bids']
                    bids.push({
                        bidder: userName,
                        bid: info['price'],
                    })
                    auction['currentBid'] = info['price']
                } else if (action === 'cancel') {
                    setNewOwner(userName)
                    asset['owner'] = userName
                    setCanceled(true)
                } else if (action === 'claim') {
                    setTransferred(true)
                }
            }
        }

        setIsLoading(false)
    }

    const prevAsset = async () => {
        if (currentAsset > 0) setCurrentAsset(currentAsset - 1)
        else setCurrentAsset(assets.length - 1)
    }

    const nextAsset = async () => {
        if (currentAsset === assets.length - 1) setCurrentAsset(0)
        else setCurrentAsset(currentAsset + 1)
    }

    const toggleShowMenu = () => {
        setShowMenu(!showMenu)
    }

    /* check box and share  */
    const cardHeader = (
        <div className={'absolute w-full h-8 z-10'}>
            <div className={'absolute flex m-auto h-10 w-8'}></div>
            <div />
            <div />
            <MoreOptions
                setShowMenu={setShowMenu}
                newOwner={newOwner}
                showMenu={showMenu}
                asset={asset}
                handleCallBack={handleCallBack}
                setIsLoading={setIsLoading}
                transferred={transferred}
                toggleShowMenu={toggleShowMenu}
                setAction={setAction}
            />
        </div>
    )

    const href = '/auction/' + market + '/' + auctionId

    const { isOpen, onOpen, onOpenChange } = useDisclosure()

    const { toast } = useToast()

    const callBack = (info, localAction = null) => {
        if (info?.success) {
            if (info?.transactionId) {
                showSuccessToast(
                    toast,
                    <Link2
                        external={true}
                        href={
                            'https://waxblock.io/transaction/' +
                            info.transactionId
                        }
                    >
                        <div className={'text-xs font-medium'}>
                            {info.transactionId.substr(0, 32) + '...'}
                        </div>
                    </Link2>,
                )
            }
        }
        if (info?.error) {
            showErrorToast(toast, info.error)
        }

        handleCallBack(info, localAction ? localAction : action)

        setAction(null)
    }

    const auctionButtons = (
        <AuctionButtons
            className={'-mt-4 h-full w-full md1:w-[380px] '}
            onAdd={onAdd}
            auction={auction}
            newOwner={newOwner}
            searchOwner={searchOwner}
            claimer={claimer}
            callBack={callBack}
            ended={ended}
            bidPlaced={bidPlaced}
            assetType={assetType}
            page={page}
            canceled={canceled}
            transferred={transferred}
            error={error}
            setError={setError}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            showOwner={showOwner}
            currentAsset={currentAsset}
            setAction={setAction}
            action={action}
            onOpen={onOpen}
        />
    )

    return (
        <LazyLoad offset={200}>
            <div>
                <MarketCard height={'high'} cardHeader={cardHeader} page={page}>
                    <ModalActions
                        action={action}
                        auction={auction}
                        callBack={callBack}
                    />
                    <div
                        className={
                            ' relative flex  justify-center items-center  !aspect-1 '
                        }
                    >
                        <div
                            className={cn(
                                'flex justify-center items-center w-full h-full',
                            )}
                        >
                            <Link2
                                inactive={
                                    page === 'newbuyoffer' ||
                                    page === 'editor' ||
                                    clickAsset
                                }
                                href={href}
                                onClick={(e) => {
                                    const elem = window.document.getElementById(
                                        'AssetDetailsPopupContent' +
                                            (assetId
                                                ? assetId
                                                : template?.templateId),
                                    )
                                    if (!elem || !elem.contains(e.target)) {
                                        dispatch({
                                            type: 'SET_ACTION_SEARCH',
                                            payload: {
                                                actionSearch: '',
                                                asset: null,
                                                searchType: '',
                                                searchID: '',
                                                includeDrops: false,
                                            },
                                        })
                                    }
                                }}
                                altOnClick={
                                    clickAsset
                                        ? () => clickAsset(index)
                                        : () => {}
                                }
                                className={cn('h-full w-full ')}
                            >
                                <div
                                    className={cn(
                                        'text-center cursor-pointer h-full w-full',
                                    )}
                                >
                                    <Tooltip
                                        leaveDelay={100}
                                        title={
                                            <AssetDetailsPopupContent
                                                asset={asset}
                                                listing={auction}
                                                userName={userName}
                                            />
                                        }
                                        placement="right"
                                        arrow
                                        enterDelay={700}
                                        enterNextDelay={700}
                                        disableTouchListener
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    borderRadius: '1rem',
                                                    backgroundColor:
                                                        theme === 'light'
                                                            ? 'white'
                                                            : '#141414FA',
                                                    maxWidth: 'none',
                                                },
                                            },
                                        }}
                                    >
                                        <div className="w-full h-full overflow-hidden">
                                            <AssetPreviewDisplay
                                                asset={assets[currentAsset]}
                                                currentAsset={currentAsset}
                                                previewDuration={
                                                    previewDuration
                                                }
                                                className={cn('h-full')}
                                                imgClassName={cn(
                                                    'object-contain transition transform h-full w-full',
                                                    'duration-500 md:hover:scale-100 hover:scale-105  cursor-pointer',
                                                )}
                                            />
                                        </div>
                                    </Tooltip>
                                </div>
                            </Link2>

                            {assets.length > 1 ? (
                                <button
                                    className={cn(
                                        'absolute m-auto h-full border-0 text-primary cursor-pointer',
                                        'outline-none text-2xl left-0 opacity-80 hover:opacity-100 w-5 h-5',
                                    )}
                                    onClick={prevAsset}
                                >
                                    ‹
                                </button>
                            ) : null}
                            {assets.length > 1 && (
                                <button
                                    className={cn(
                                        'absolute m-auto h-full border-0 text-primary cursor-pointer',
                                        'outline-none text-2xl right-0 opacity-80 hover:opacity-100 w-5 h-5',
                                    )}
                                    onClick={nextAsset}
                                >
                                    ›
                                </button>
                            )}
                        </div>
                        {mint && !rank && !rarityScore ? (
                            <MintInfo top={'-bottom-4 right-1'} mint={mint} />
                        ) : (
                            ''
                        )}
                        {rank && rarityScore ? (
                            <RankInfo rank={rank} rarityScore={rarityScore} />
                        ) : (
                            ''
                        )}
                        {backedTokens && (
                            <BackedInfo backedTokens={backedTokens} />
                        )}
                    </div>
                    <div
                        className={'p-4 flex flex-wrap h-full justify-between'}
                    >
                        <CollectionAssetName
                            linkInactive={
                                page === 'newbuyoffer' ||
                                page === 'editor' ||
                                clickAsset
                            }
                            onClick={() => {
                                dispatch({
                                    type: 'SET_ACTION_SEARCH',
                                    payload: {
                                        actionSearch: '',
                                        asset: null,
                                        searchType: '',
                                        searchID: '',
                                        includeDrops: false,
                                    },
                                })
                            }}
                            altOnClick={
                                clickAsset ? () => clickAsset(index) : () => {}
                            }
                            href={href}
                            name={name}
                            collection={collection}
                        />

                        {auctionButtons}

                        <AuctionTimeleft
                            auction={auction}
                            ended={ended}
                            setEnded={setEnded}
                        />
                    </div>
                </MarketCard>

                <Modal
                    size={'5xl'}
                    isOpen={isOpen}
                    onOpenChange={onOpenChange}
                    scrollBehavior={'inside'}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    classNames={{
                        body: 'p-0',
                        closeButton:
                            'absolute top-2 right-2 z-50 bg-red-500 text-white hover:bg-red-600',
                    }}
                >
                    <ModalContent>
                        <ModalBody className="w-full px-0 py-0 ">
                            <MarketAssetPreviewInfo
                                asset={asset}
                                listing={auction}
                                newOwner={newOwner}
                                currentAsset={currentAsset}
                                show={onOpen}
                                buttons={auctionButtons}
                            />
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </div>
        </LazyLoad>
    )
}

function assetPropsAreEqual(prevAsset, nextAsset) {
    const id1 = prevAsset.auctionId
    const id2 = nextAsset.auctionId

    return id1 === id2 && prevAsset.index === nextAsset.index
}

export default React.memo(AuctionAssetPreview, assetPropsAreEqual)
